import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Box, Paper, Stack, Tooltip, Typography } from "@mui/material";
import { typography } from "@mui/system";

//import Logo from "../Header/Logo";

const TimeTableCell = ({ obj, val, lbl, setLocalState, localState, manageOnMouseUp, manageOnMouseOver, manageClick }) => {
	function mouseDown(uid) {
		console.log("mouseDown", uid)
		setLocalState({ ...localState, drag: true, start_cell: obj.i, start_cell_day: obj.d })
	}

	return (
		<Box
			// onClick={() => {
			// 	manageClick(uid);
			// }}

			p={0.5}
			style="width: 100%; margin: 0px;"
		>

			<Fragment style=" ">
				{[-1, 1].includes(val) && (
					<Paper style="text-align: center; padding: 4px; margin: 0px;" onClick={() => manageClick(obj.i)} onmouseover={() => manageOnMouseOver(obj.i)} onmousedown={() => mouseDown(obj.i)} onmouseup={() => manageOnMouseUp(obj.i)}>
						<Typography variant="body1" style="text-align: center; padding: 0px; cursor: pointer; -moz-user-select: none; webkit-user-select: none; user-select: none; -ms-user-select: none;" >
							-
						</Typography>
					</Paper>
				)}
				{[-2, 2].includes(val) && (
					// <Paper style="text-align: center; padding: 2px; background-color: rgba(76, 175, 80, 0.51); vertical-align: center">
					<Paper style="text-align: center; padding: 4px; background-color: #e8e8e8;" onClick={() => manageClick(obj.i)}>
						<div style="display: flex; align-items: center; justify-content: center">
							<Logo color="primary" />
						</div>
					</Paper>
				)}
			</Fragment>

		</Box>
	);
};

const TimeTableCaption = ({ val, toggleOneDay, week }) => {

	return (
		<Box p={0.5}
			style="width: 100%" >
			{val !== "" && (
				<Paper
					style={`text-align: center; padding-bottom: 2px; padding-top: 2px; cursor: pointer; color: #FF3426; ${week.includes(val) ? "background-color: #FFEFEE;" : ""}`}
					onClick={toggleOneDay}>
					<Typography variant="body1" style={"color: #FF3426;"}>{d_to_name(val)}</Typography>
				</Paper>
			)}
		</Box>
	);
};
//[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
export default function MasterWeekViewV2(props) {
	console.log("MasterWeekViewV2", props)
	const [localState, setLocalState] = useState({ week: [1, 2, 3, 4, 5, 6, 7], hours: timeTable });

	const manageOnMouseUp = (end_idx) => {
		console.log(localState)
		if (localState.drag === true && localState.start_cell_day === props.state.ambassador_slots[end_idx].d) {

			var new_state = props.state.ambassador_slots_states;

			const sub_array_slots = props.state.ambassador_slots.reduce((acc, slt) => {
				if (slt.i >= localState.start_cell && slt.i <= localState.end_cell) {
					acc[slt.u] = 2;

				}
				return acc
			}, {})

			props.setUpperState({ ...new_state, ...sub_array_slots })
			setLocalState({ ...localState, drag: false, start_cell: undefined, start_cell_day: undefined, end_cell: undefined })

		}
	}

	const manageOnMouseOver = (uid) => {
		if (localState.drag === true && localState.start_cell_day === props.state.ambassador_slots[uid].d) {
			console.log("mouseOver", uid)
			var new_state = props.state.ambassador_slots_states;

			const sub_array_slots = props.state.ambassador_slots.reduce((acc, slt) => {
				if (slt.i >= localState.start_cell && slt.i <= localState.end_cell) {
					acc[slt.u] = 2;

				}
				return acc
			}, {})

			props.setUpperState({ ...new_state, ...sub_array_slots })
			setLocalState({ ...localState, drag: true, end_cell: uid })
		}
	}
	const manageClick = (uid) => {
		console.log("manageClick", uid, props.state.ambassador_slots_states, props.state.ambassador_slots_states[props.state.ambassador_slots[uid].u])
		var new_state = props.state.ambassador_slots_states;
		switch (Math.abs(new_state[props.state.ambassador_slots[uid].u])) {
			case 1:
				new_state[props.state.ambassador_slots[uid].u] = 2;
				break;
			case 2:
				new_state[props.state.ambassador_slots[uid].u] = 1;
				break;
		}
		props.setUpperState({ ...new_state })
		setLocalState({ ...localState, drag: false, start_cell: undefined, start_cell_day: undefined, end_cell: undefined })
	}
	const toggleOneHour = (h) => {

		console.log("toggleonehour", h, timeTable.indexOf(h), localState.hours.indexOf(h));
		var nf = localState.hours;
		var val;
		console.log(nf, nf.indexOf(h))
		if (nf.indexOf(h) === -1) {
			nf = nf.concat(h)
			val = 1;
		} else {
			//	console.log("toggle on")
			nf = nf.filter((f) => { return f !== h })
			val = 2;
		}
		var new_state = props.state.ambassador_slots_states;
		const sub_array_slots = props.state.ambassador_slots.filter((obj) => { return obj.h === (h) }).reduce((acc, slt) => {
			//console.log(slt)
			acc[slt.u] = val;

			return acc
		}, {})
		props.setUpperState({ ...new_state, ...sub_array_slots })
		setLocalState({ ...localState, hours: nf });
	}
	const toggleOneDay = (day) => {
		//console.log("toogleOneDay", day)
		var nf = localState.week;
		var val;
		if (nf.indexOf(day) === -1) {
			nf = nf.concat(day)
			val = 1;
		} else {
			//	console.log("toggle on")
			nf = nf.filter((f) => { return f !== day })
			val = 2;
		}

		var new_state = props.state.ambassador_slots_states;

		const sub_array_slots = props.state.ambassador_slots.filter((obj) => { return obj.d === (day) }).reduce((acc, slt) => {

			acc[slt.u] = val;

			return acc
		}, {})

		props.setUpperState({ ...new_state, ...sub_array_slots })
		setLocalState({ ...localState, week: nf });
	};
	//console.log(props)
	return (
		<Paper style="padding: 20px; background-color: rgba(244, 246, 248, 0.81);">

			<Box display={"flex"} justifyContent={"space-between"} >
				<Box p={0.5} >
					<Stack spacing={1}>
						<Paper style="padding: 4px; visibility: hidden">
							<Typography variant="body1">00:00</Typography>
						</Paper>
						{timeTable.map((hh) => {

							return <Paper style="padding: 4px; cursor: pointer; -moz-user-select: none; webkit-user-select: none; user-select: none; -ms-user-select: none;" onClick={() => { toggleOneHour(hh) }}>{hh}</Paper>

						})}
					</Stack>
				</Box>
				{[1, 2, 3, 4, 5, 6, 7].map((d) => {

					return <Box p={0.5} style="width: 100%;" >
						<Stack spacing={1}>
							<TimeTableCaption
								week={localState.week}
								val={"d" + d}
								toggleOneDay={() => { toggleOneDay(d) }} />

							{props.state.ambassador_slots.filter((obj) => { return obj.d === d }).map((hh) => {

								return <TimeTableCell
									val={props.state.ambassador_slots_states[hh.u]}
									obj={hh}
									manageClick={manageClick}

									lbl=""
									setLocalState={setLocalState}
									localState={localState}
									manageOnMouseUp={manageOnMouseUp}
									manageOnMouseOver={manageOnMouseOver}
									week={props.state.week}
								/>
							})}
						</Stack>
					</Box>
				})}
			</Box>

		</Paper >
	);
}

const d_to_name = (d) => {
	switch (d) {
		case "d1":
			return "Lun"
			break;
		case "d2":
			return "Mar"
			break;
		case "d3":
			return "Mer"
			break;
		case "d4":
			return "Jeu"
			break;
		case "d5":
			return "Ven"
			break;
		case "d6":
			return "Sam"
			break;
		case "d7":
			return "Dim"
			break;
	}
}
const timeTable = new Array(
	"08:00",
	"08:30",
	"09:00",
	"09:30",
	"10:00",
	"10:30",
	"11:00",
	"11:30",
	"12:00",
	"12:30",
	"13:00",
	"13:30",
	"14:00",
	"14:30",
	"15:00",
	"15:30",
	"16:00",
	"16:30",
	"17:00",
	"17:30",
	"18:00",
	"18:30",
	"19:00",
	"19:30",
	"20:00"
);

const timeTable2 = {
	"08:00": { s: "08:00", e: "08:30" },
	"08:30": { s: "08:30", e: "09:00" },
	"09:00": { s: "09:00", e: "09:30" },
	"09:30": { s: "09:30", e: "10:00" },
	"10:00": { s: "10:00", e: "10:30" },
	"10:30": { s: "10:30", e: "11:00" },
	"11:00": { s: "11:00", e: "11:30" },
	"11:30": { s: "11:30", e: "12:00" },
	"12:00": { s: "12:00", e: "12:30" },
	"12:30": { s: "12:30", e: "13:00" },
	"13:00": { s: "13:00", e: "13:30" },
	"13:30": { s: "13:30", e: "14:00" },
	"14:00": { s: "14:00", e: "14:30" },
	"14:30": { s: "14:30", e: "15:00" },
	"15:00": { s: "15:00", e: "15:30" },
	"15:30": { s: "15:30", e: "16:00" },
	"16:00": { s: "16:00", e: "16:30" },
	"16:30": { s: "16:30", e: "17:00" },
	"17:00": { s: "17:00", e: "17:30" },
	"17:30": { s: "17:30", e: "18:00" },
	"18:00": { s: "18:00", e: "18:30" },
	"18:30": { s: "18:30", e: "19:00" },
	"19:00": { s: "19:00", e: "19:30" },
	"19:30": { s: "19:30", e: "20:00" },
	"20:00": { s: "20:00", e: "20:30" },
};

function Logo() {

	return (
		<svg width="35px" height="21px" viewBox="0 0 91 50">
			<g id="design" fill="#FF3426">
				<path
					class="cls-1"
					d="M0,22.92a.65.65,0,0,1,.16-.47.57.57,0,0,1,.45-.17H9.87a5.84,5.84,0,0,1,2.31.46A5.92,5.92,0,0,1,14.08,24a6.26,6.26,0,0,1,1.29,1.9,5.8,5.8,0,0,1,.47,2.35,5.86,5.86,0,0,1-.32,1.95,5.38,5.38,0,0,1-.93,1.61A6.78,6.78,0,0,1,16.18,34a6.38,6.38,0,0,1,.58,2.69,6.14,6.14,0,0,1-.48,2.41,6.77,6.77,0,0,1-1.32,2A6.35,6.35,0,0,1,13,42.47a5.64,5.64,0,0,1-2.33.5H.61a.63.63,0,0,1-.44-.15A.57.57,0,0,1,0,42.37Zm10.49,5.49A2,2,0,0,0,9.91,27a1.91,1.91,0,0,0-.67-.44,2.23,2.23,0,0,0-.86-.16h-3v4h3a2.41,2.41,0,0,0,.87-.15,1.74,1.74,0,0,0,.68-.42,2,2,0,0,0,.6-1.45Zm.74,8.09a2.22,2.22,0,0,0-.16-.83,2.58,2.58,0,0,0-.45-.75,2.35,2.35,0,0,0-.68-.53,1.82,1.82,0,0,0-.86-.21H5.39v4.65H9.08a1.86,1.86,0,0,0,.85-.19,2.36,2.36,0,0,0,.69-.53,2.53,2.53,0,0,0,.45-.74A2.35,2.35,0,0,0,11.23,36.5Z"
				/>
				<path
					class="cls-1"
					d="M53.61,40.85a9.33,9.33,0,0,1-2.76,1.76,8.3,8.3,0,0,1-3.25.64A9.38,9.38,0,0,1,39,37.72a8.82,8.82,0,0,1-.75-3.64,9.41,9.41,0,0,1,.3-2.38,9.83,9.83,0,0,1,.85-2.15,9.28,9.28,0,0,1,1.34-1.85,8.4,8.4,0,0,1,1.76-1.44A8.72,8.72,0,0,1,47,25a8.35,8.35,0,0,1,2.24.31,8.63,8.63,0,0,1,2,.86A9.06,9.06,0,0,1,53,27.5a8.94,8.94,0,0,1,1.37,1.71,8.4,8.4,0,0,1,.89,2,7.83,7.83,0,0,1,.31,2.16c0,.49,0,.88,0,1.19a1.37,1.37,0,0,1-.22.73,1,1,0,0,1-.65.38,6.33,6.33,0,0,1-1.33.1h-10a3.44,3.44,0,0,0,.56,1.49,3.75,3.75,0,0,0,1,1,4.26,4.26,0,0,0,1.18.51,5.1,5.1,0,0,0,1.19.15,5.39,5.39,0,0,0,1-.11,8.48,8.48,0,0,0,1-.27,6.94,6.94,0,0,0,.91-.41,3,3,0,0,0,.66-.48,2.79,2.79,0,0,1,.38-.27.69.69,0,0,1,.34-.09.68.68,0,0,1,.37.12,3.18,3.18,0,0,1,.43.37l1.47,1.67a.86.86,0,0,1,.2.33,1,1,0,0,1,0,.3.81.81,0,0,1-.15.48A1.71,1.71,0,0,1,53.61,40.85ZM46.9,29.24a2.74,2.74,0,0,0-1,.22,3.73,3.73,0,0,0-1,.58,4.44,4.44,0,0,0-.8.82,5.25,5.25,0,0,0-.58.93h7.12a9,9,0,0,0-.64-1,3.75,3.75,0,0,0-.78-.81,3.32,3.32,0,0,0-1-.54A4,4,0,0,0,46.9,29.24Z"
				/>
				<path
					class="cls-1"
					d="M56.6,26.61a1.09,1.09,0,0,1,0-.95c.15-.27.47-.4,1-.4H61a.8.8,0,0,1,.57.21,1.5,1.5,0,0,1,.34.54l3.94,11.22L69.7,26a1.08,1.08,0,0,1,.39-.6,1.24,1.24,0,0,1,.66-.15h3.58a1.46,1.46,0,0,1,.61.1.66.66,0,0,1,.31.28.74.74,0,0,1,.07.39,1.62,1.62,0,0,1-.12.43l-1.15,2.86-1.3,3.23c-.46,1.12-.91,2.26-1.38,3.42s-.91,2.29-1.36,3.4l-1.27,3.22c-.41,1-.78,2-1.12,2.83S67,47,66.73,47.68l-.57,1.5,0-.07a1.12,1.12,0,0,1-.35.61.87.87,0,0,1-.61.23H62a1.15,1.15,0,0,1-.85-.24,1,1,0,0,1-.23-.72.72.72,0,0,1,0-.28c0-.06.06-.11.08-.12l2.19-5.69Z"
				/>
				<path
					class="cls-1"
					d="M80.1,37.47a4,4,0,0,0,.81.63,6.57,6.57,0,0,0,.84.42,7.1,7.1,0,0,0,.71.23,3.44,3.44,0,0,0,.42.07l.68,0a4.2,4.2,0,0,0,.79-.13,1.58,1.58,0,0,0,.64-.34.85.85,0,0,0,.28-.67,1.11,1.11,0,0,0-.16-.62,1.3,1.3,0,0,0-.44-.39,4.14,4.14,0,0,0-.72-.29l-1-.29A11.69,11.69,0,0,1,80.23,35a6.51,6.51,0,0,1-1.72-1.4,4.64,4.64,0,0,1-.88-1.67,6.78,6.78,0,0,1-.25-1.88,4.64,4.64,0,0,1,1.77-3.73,6.18,6.18,0,0,1,2-1,8.73,8.73,0,0,1,2.64-.37,8.55,8.55,0,0,1,1.64.15,6.06,6.06,0,0,1,1.46.46,7,7,0,0,1,1.36.8A11.68,11.68,0,0,1,89.6,27.5a.84.84,0,0,1,.24.52.72.72,0,0,1-.31.53c-.36.29-.71.59-1,.87s-.67.61-1,1a.78.78,0,0,1-.34.17.69.69,0,0,1-.32,0,.71.71,0,0,1-.29-.14,1.09,1.09,0,0,1-.25-.23,2.43,2.43,0,0,0-1.12-.73A3.86,3.86,0,0,0,84,29.26a2.22,2.22,0,0,0-1.08.23.74.74,0,0,0-.38.73.77.77,0,0,0,.27.56,1.73,1.73,0,0,0,.6.33,5.89,5.89,0,0,0,.75.2,6.69,6.69,0,0,1,.74.18,20.7,20.7,0,0,1,2.29.88A7,7,0,0,1,89,33.53a4.92,4.92,0,0,1,1.19,1.65,5.83,5.83,0,0,1,.42,2.34,5.22,5.22,0,0,1-2.06,4.29,6.76,6.76,0,0,1-2.28,1.13,9.93,9.93,0,0,1-2.83.39,10.55,10.55,0,0,1-1.76-.15,8.14,8.14,0,0,1-1.73-.5,8,8,0,0,1-1.59-.87A6.35,6.35,0,0,1,77,40.5a1.2,1.2,0,0,1-.23-.41.89.89,0,0,1-.07-.42,1,1,0,0,1,.08-.39A.84.84,0,0,1,77,39l1.8-1.79a.64.64,0,0,1,.59-.2A2,2,0,0,1,80.1,37.47Z"
				/>
				<polyline class="cls-1" points="24.64 17.43 24.64 30.98 24.64 32.94 24.64 37.19 24.64 42.94 18.84 42.94 18.84 17.43" />
				<path
					class="cls-1"
					d="M21.74,5.79A3.16,3.16,0,1,1,18.58,9a3.17,3.17,0,0,1,3.16-3.16m2.9,11.64A9,9,0,0,0,21.74,0h0a9,9,0,0,0-2.9,17.43"
				/>
				<path
					class="cls-1"
					d="M24.59,31l4.77-5.31a1.13,1.13,0,0,1,.87-.41h4.28c.51,0,.76.2.76.6a.47.47,0,0,1-.05.25,1.38,1.38,0,0,1-.2.28l-5.73,6.05L36.5,41.7h0a1.2,1.2,0,0,1,.26.37.94.94,0,0,1,.07.34.48.48,0,0,1-.17.44.93.93,0,0,1-.52.12H31.4a.68.68,0,0,1-.45-.18,3,3,0,0,1-.46-.54l-4.55-6.46-1.35,1.4"
				/>
			</g>
		</svg>
	);
}